export default __webpack_public_path__ + "static/django-icon-dd484a68bd2b59d10ede3e37568a5e53.svg";